import {
  Filter,
  GridComponent,
  GridModel,
  InfiniteScroll,
  Inject,
  Page,
  Reorder,
  Sort,
  Toolbar,
  Resize,
  Group,
  Search,
  ExcelExport,
  ContextMenu,
  VirtualScroll,
  ColumnChooser,
} from "@syncfusion/ej2-react-grids";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import {
  TooltipComponent,
  TooltipEventArgs,
} from "@syncfusion/ej2-react-popups";
import React, { createContext } from "react";
import classNames from "classnames";
import { sanitizeHtml } from "../../../utils/markup";

export const GridInstanceContext = createContext<GridComponent | null>(null);

export interface SecondaryGridComponentProps {
  ready: boolean;
  gridRef: React.RefObject<GridComponent | null>;
  gridSettings?: GridModel & DefaultHtmlAttributes;
  className?: string;
}

const SecondaryGridComponent = (props: SecondaryGridComponentProps) => {
  const [tooltipText, setTooltipText] = React.useState<string>();
  // Set Tooltip on Column hover
  const beforeRender = (args: TooltipEventArgs) => {
    // Only show a tooltip for long character-length column values.
    if (!args.target.innerText || args.target.innerText.length < 25) {
      args.cancel = true;
    }

    // Replace double quotes with HTML entity &quot. To avoid breaking the tooltip.
    const escapedText = args.target.innerText.replace(/"/g, "&quot;");

    // Sanitize the text to mitigate XSS vulnerabilities in TooltipComponent
    const sanitizedText = sanitizeHtml(escapedText);

    setTooltipText(sanitizedText);
  };

  return (
    <div className="ucl-grid-container">
      {props.ready && (
        <TooltipComponent
          id="Tooltip"
          target=".e-rowcell"
          beforeRender={beforeRender}
          content={tooltipText}
          className={classNames("primary-grid", props.className || "")}
        >
          <GridInstanceContext.Provider value={props.gridRef.current}>
            <GridComponent
              ref={props.gridRef}
              className="ucl-grid"
              {...props.gridSettings}
            >
              <Inject
                services={[
                  Page,
                  Sort,
                  Filter,
                  Group,
                  Toolbar,
                  Reorder,
                  Resize,
                  InfiniteScroll,
                  VirtualScroll,
                  Search,
                  ExcelExport,
                  ContextMenu,
                  ColumnChooser,
                ]}
              />
            </GridComponent>
          </GridInstanceContext.Provider>
        </TooltipComponent>
      )}
      {!props.ready && <></>}
    </div>
  );
};

const SecondaryGrid = SecondaryGridComponent;
export default SecondaryGrid;
